import { render } from "./TransporterIndex.vue?vue&type=template&id=58eb4977&scoped=true"
import script from "./TransporterIndex.vue?vue&type=script&lang=js"
export * from "./TransporterIndex.vue?vue&type=script&lang=js"

import "./TransporterIndex.vue?vue&type=style&index=0&id=58eb4977&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58eb4977"]])

export default __exports__